<main class="d-flex flex-column justify-content-center align-items-center px-5 pt-5" style="min-height: 75vh;">
  <img src="assets/icons/404.svg" alt="404 image" class="w-50">
  <h2 class="mt-3 text-center">{{ 'NOTFOUND.TITLE' | translate }}</h2>
  <p class="lead text-center">{{ 'NOTFOUND.P1' | translate }}</p>
  <h4 class="mb-5 text-center">{{ 'NOTFOUND.P2' | translate }}</h4>
  <button class="btn btn-outline-secondary" type="button" routerLink="">{{'NOTFOUND.HOME_LINK_LABEL' | translate}}</button>
</main>
